import { IBasstrakkAngler, IBasstrakkCatch } from '../types';

/**
 * Combines api data for the "Catch Times" table
 *
 * @param {IBasstrakkAngler[]} anglers
 * @param {IBasstrakkCatch[]} catches
 */
const useCatchesTableData = (
  anglers: IBasstrakkAngler[],
  catches: IBasstrakkCatch[]
) => {
  if (catches && catches.length) {
    // Find the leading catch
    const leader = catches.reduce((prev, current) => {
      return prev.FishWeightOz > current.FishWeightOz ? prev : current;
    });
    return catches.map(c => {
      const angler = anglers?.filter(a => a.FISHERMENID === c.AnglerId)[0];
      const anglerCatches = angler
        ? catches.filter(ac => ac.AnglerId === angler.FISHERMENID)
        : [];
      return {
        ...c,
        Catches: anglerCatches,
        Angler: angler,
        BigBassLeader: leader,
      };
    });
  }
  return [];
};

export default useCatchesTableData;
